import styled, { css } from 'styled-components'
import { device } from '../../styles/Breakpoints'
import { Container } from '../../styles/Wrappers'

export const SpotlightWrapper = styled(Container)`
	display: flex;
	flex-direction: column;

	@media ${device.sm} {
		flex-direction: row;
	}
`

export const SpotlightLeft = styled.div`
	display: flex;
	flex-direction: column;
	background-color: var(--grey-44);
	padding: 25px;
	order: 2;

	@media ${device.sm} {
		order: 1;
		width: 75%;
	}
`

export const SpotlightCustomer = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;

	p {
		margin: 0;
	}

	@media ${device.sm} {
		margin-bottom: 0px;
	}
`

export const SpotlightRight = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	order: 1;
	padding: 25px;
	box-shadow: 5px 5px var(--grey-22);
	z-index: 1;

	${({ colorlist }) =>
		colorlist &&
		css`
			background-color: ${colorlist.value};
		`};

	@media ${device.sm} {
		margin-top: -20px;
		margin-bottom: -20px;
		order: 2;
		width: 25%;
	}
`

export const SpotlightCustomerImage = styled.div`
	max-width: 150px;

	img {
		width: 100%;
		border-radius: 50%;
		border: 2px solid #fff;
	}
`

export const SpotlightCustomerLogo = styled.div`
	max-width: 250px;

	img {
		width: 100%;
	}
`

export const SpotlightCopy = styled.div`
	display: flex;

	img {
		max-width: 60px;
	}
`

export const SpotlightAuthorAndCTA = styled.div`
	display: flex;
	flex-direction: column;

	@media ${device.sm} {
		align-items: center;
		justify-content: space-between;
		flex-direction: row;
	}
`
